export const textStyles = {
  message: {
    fontSize     : 14,
    marginBottom : 10,
  },
};
